<template>
  <div>
    <div class="title_h1">資料連携</div>
    <vab-collapse-info>
      <template slot="title">
        {{ getFieldValue('demandBaseIdModel.title', info) }}
        ［ {{ getFieldValue('purchaseOrderBaseIdModel.acceptOrderKey', info) }}
        ］
      </template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            <div class="flex_space width_100">
              <div>
                {{
                  getFieldValue(
                    'purchaseOrderBaseIdModel.buildingCdMbuildgpModel.blgsnmkj',
                    info
                  )
                }}
              </div>
              <!-- <div class="sub_title">
                （建物ＣＤ：{{
                  getFieldValue('demandBaseIdModel.buildingCd', info)
                }}）
              </div> -->
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">商品</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            <div class="flex_space width_100">
              <div>
                {{ getFieldValue('demandBaseIdModel.itemCdModel.itmnm', info) }}
              </div>
              <!-- <div class="sub_title">
                （商品ＣＤ：{{
                  getFieldValue('demandBaseIdModel.itemCd', info)
                }}）
              </div> -->
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">商品明細</vab-col>
          <vab-col :span="8" class="word_box center_box">
            <div class="flex_space width_100">
              <div>
                {{
                  getFieldValue(
                    'purchaseOrderBaseIdModel.itemCdModel.itmdtlnm',
                    info
                  )
                }}
              </div>
              <!-- <div class="sub_title">
                （商品明細ＣＤ：{{
                  getFieldValue('purchaseOrderBaseIdModel.itemDetailCd', info)
                }}）
              </div> -->
            </div>
          </vab-col>

          <vab-col :span="4" class="title_box">セグメント</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('demandBaseIdModel.demandType', info),
                $divisions.demandTypeEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">案件分類</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('demandBaseIdModel.businessForm', info),
                $divisions.consignmentWorkClassEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">計上部門</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue(
                'demandBaseIdModel.accountingDepCdModel.orgkj',
                info
              )
            }}
            <!-- <div class="sub_title">
                （部門ＣＤ：{{
                  getFieldValue('demandBaseIdModel.accountingDepCd', info)
                }}）
              </div> -->
          </vab-col>
          <vab-col :span="4" class="title_box">進行部門</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{
                  getFieldValue(
                    'purchaseOrderBaseIdModel.purchaseOrderDepCdModel.orgkj',
                    info
                  )
                }}
              </div>
              <!-- <div class="sub_title">
                （部門ＣＤ：{{
                  getFieldValue(
                    'purchaseOrderBaseIdModel.purchaseOrderDepCd',
                    info
                  )
                }}）
              </div> -->
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">進行担当者</vab-col>
          <vab-col :span="8" class="word_box center_box">
            <div
              v-for="(item, index) in getFieldValue(
                'purchaseOrderBaseIdModel.purchaseOrderChargePersonModelList',
                info
              )"
              :key="index"
            >
              {{ getFieldValue('empnmkj', item.chargePersonCdModel) }}
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">協力会社</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue(
                'purchaseOrderBaseIdModel.supplierCdModel.bcnfrkj',
                info
              )
            }}
            <!-- <div class="sub_title">
                （協力会社ＣＤ：
                {{
                  getFieldValue('purchaseOrderBaseIdModel.supplierCd', info)
                }}）
              </div> -->
          </vab-col>
          <vab-col :span="4" class="title_box">納品予定年月</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{
              getFomateMonth(
                getFieldValue('demandBaseIdModel.contractEndDate', info)
              )
            }}
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>

    <div class="info_main">
      <div class="head_box flex_start flex_center_align">
        <svg-icon icon-class="edit_2_line"></svg-icon>
        <span class="hd_title">{{ showTitleByDemandType() }}</span>
      </div>
      <vab-form ref="form" :model="form">
        <div class="sure_box border_top_none border_bottom_none">
          <div class="file_box norborder">
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">
                <div class="flex_colum">
                  <div class="gyzl">共有資料</div>
                </div>
              </vab-col>
              <vab-col
                :span="20"
                class="common_data_file word_box border_left_none"
              >
                <div class="common_data_file_box">
                  <div
                    v-if="fileList.length > 0"
                    class="word_col_upload_filebox"
                  >
                    <div
                      v-for="(item, index) in fileList"
                      :key="index"
                      class="file_inner_item flex_start pl0"
                      :class="{ disabled_file_name: disabledFileName(item) }"
                    >
                      <div class="arrow_box">
                        <svg-icon icon-class="tryangle_right" class="arrow" />
                      </div>
                      <div class="file_name_out_box">
                        <div class="flex_colum file_name_box">
                          <span class="file_name" @click="downLoad(item)">
                            {{ item.fileName }}
                          </span>
                          <div class="file_time">
                            アップロード日時：{{ item.createDate }}
                            {{ formatTimeMsel(item.createTime) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">コメント</vab-col>
              <vab-col :span="20" class="word_box">
                <div class="pre_wrap">
                  {{ getFieldValue('fileRemarks', info) }}
                </div>
              </vab-col>
            </vab-row>
          </div>
        </div>
      </vab-form>
    </div>
  </div>
</template>

<script>
  import {
    workImplementStatusInfo,
    listFiles,
    dlnDownload,
  } from '@/api/workImplementStatus'
  import mixinPage from '@/utils/mixinPage'
  import mixinSchedule from '@/utils/mixinSchedule'
  export default {
    name: 'DWS03G04',
    mixins: [mixinPage, mixinSchedule],
    data() {
      return {
        form: {},
        info: {},
        uploadData: {},
        fileList: [],
        btnList: [
          {
            name: ' 連携 ',
            icon: 'answer',
            msg: this.$t(`validateMessage.${this.$messageCode.I00000270.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000448.name}`
            ),
            type: 'button',
            hidden: false,
            click: (row) => {
              this.sumbitForm(row)
            },
          },
        ],
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      async initData() {
        // 実施状況ＩＤ
        let implementStatusId = this.$route.query?.implementStatusId
        if (implementStatusId) {
          // 工事（作業）実施状況取得
          await this.getWorkImplementStatusInfo(implementStatusId)
          // 共有資料リスト
          await this.getListFiles()
        }
      },
      // タイトルを表示する
      showTitleByDemandType() {
        if (
          this.isEqualCodeEnum(
            this.info?.demandBaseIdModel?.demandType,
            this.$divisions.demandTypeEnum.enum_2
          )
        ) {
          return '掲示物'
        }
        if (
          this.isEqualCodeEnum(
            this.info?.demandBaseIdModel?.demandType,
            this.$divisions.demandTypeEnum.enum_3
          )
        ) {
          return '作業リマインド'
        }
      },
      // 工事（作業）実施状況取得
      async getWorkImplementStatusInfo(implementStatusId) {
        const res = await workImplementStatusInfo(implementStatusId)
        if (!res) return
        this.info = res
        this.showTitleByDemandType()
        this.uploadData = {
          // 受注キー
          acceptOrderKey: this.getFieldValue(
            'purchaseOrderBaseIdModel.acceptOrderKey',
            res
          ),
          // 建物CD
          buildingCd: this.getFieldValue('demandBaseIdModel.buildingCd', res),
          // 建物CD
          demandType: this.getFieldValue('demandBaseIdModel.demandType', res),
          // 実施状況ｉｄ
          implementStatusId: this.getFieldValue('implementStatusId', res),
          // 発注基本ｉｄ
          purchaseOrderBaseId: this.getFieldValue(
            'purchaseOrderBaseIdModel.purchaseOrderBaseId',
            res
          ),
          // 発注先ＣＤ
          supplierCd: this.getFieldValue(
            'purchaseOrderBaseIdModel.supplierCd',
            res
          ),
        }
      },
      // 資料連携-共有資料リスト
      async getListFiles() {
        const res = await listFiles(this.info)
        this.fileList = res
      },
      // アップロード成功コールバック
      successFile(res) {
        this.fileList.push(res)
      },
      // 報告書ダウンロード
      async downLoad(file) {
        let data = {
          ...this.uploadData,
          reportId: file?.reportId,
        }
        await dlnDownload(data)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tableInfo {
    border: 1px solid #d1dae1;
    border-radius: $base-border-radius3;
    overflow: hidden;
    .ts_box {
      background: #fff;
      padding: 10px 12px;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #003350;
      }
    }
  }
  .bj20 {
    margin-top: 20px;
  }
  .gyzl {
    line-height: 20px;
  }
  .pt10 {
    padding-top: 10px;
  }
</style>
